import { rem } from 'polished';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  gap: ${rem('13px')};
  align-items: center;

  dt:nth-child(2) {
    color: ${({ theme }) => theme.colors.tenant.main};
    cursor: pointer;
    font-size: ${rem('14px')};
    font-weight: 400;
  }
`;

export const StyledFullWidthDLItem = styled.div`
  grid-column: 1 / -1;
  grid-row: auto;
`;

export const StyledLinkToComission = styled.a`
  color: ${({ theme }) => theme.colors.cross.black};
  text-decoration: underline;
  display: flex;
  gap: ${rem('8px')};
  align-items: center;
  appearance: none;
  text-underline-offset: 4px;
  font-size: ${rem('14px')};
  width: max-content;
`;

export const StyledFullWidthDLItems = styled.div`
  grid-column: 1 / -1;
  grid-row: auto;
`;

export const StyledDDItemsToRecipts = styled.dd`
  display: grid;
  gap: 0.9375rem;
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    grid-template-columns: 1fr;
    gap: 0px;
  }
`;
